/**
 * Syncs LocalStorage favourite event IDs to Drupal DB.
 * @returns {Promise}
 */
export function syncFavouritesToDB() {

  const eventIds = Object.keys(localStorage)
    .filter((key) => key.startsWith('favouriteEventId-'))
    .map((key) => key.replace('favouriteEventId-', ''));

  if (eventIds.length === 0) {
    return Promise.resolve({ status: 'empty' });
  }

  // Get CSRF token, then POST to Drupal
  return fetch('/session/token')
    .then((response) => response.text())
    .then((token) => {
      return fetch('/api/favourites/sync', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ event_ids: eventIds }),
      });
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 'success') {
        // Clean up LocalStorage (after sync).
        data.saved.forEach(id => {
          localStorage.removeItem(`favouriteEventId-${id}`);
        });
      }
      return data;
    })
    .catch((error) => {
      console.error('Failed to sync favourites to DB:', error);
    });

}
